import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";

/** Nextjs */

/** worker */
import WebWorker from "@/src/_common/WebWorker";
import { HousekeeperWorker } from "./housekeeperWorker";

/** Redux */
import { useDispatch } from "react-redux";
import { deleteDatabase } from "@/src/_appStore/utils/_idb_COMMON";
import {
    clearAggregatesFromIndexedDB,
    clearAreasFromIndexedDB,
    clearCATCalculatorsFromIndexedDB,
    clearCATCommonFromIndexedDB,
    clearCalendarFromIndexedDB,
    clearDATESFromIndexedDB,
    clearDBCommonFromIndexedDB,
    clearJTFromIndexedDB,
    clearListsTableFromIndexedDB,
    clearRepositoryromIndexedDB,
    clearSettingsChartBarsFromIndexedDB,
    clearSettingsTableFromIndexedDB,
    clearStorytellingFromIndexedDB,
    clearTableFiltersFromIndexedDB,
    clearVALCommonFromIndexedDB,
    clearWSKFromIndexedDB,
} from "@/src/_appStore/utils/clear";

/** API */
import { getApiVersionFromAPI, getDbStatusFromAPI, getVersionsFromAPI } from "@/src/_APIs";

import packageJson from "../../package.json";

import PagePreloader from "../_common/PagePreloader";

const VERSION_HEARTBEAT_DISABLED = process.env.NEXT_PUBLIC_VERSION_HEARTBEAT_DISABLED
    ? JSON.parse(process.env.NEXT_PUBLIC_VERSION_HEARTBEAT_DISABLED)
    : false;

const VERSION_HEARTBEAT_INTERVAL = process.env.NEXT_PUBLIC_VERSION_HEARTBEAT_INTERVAL
    ? JSON.parse(process.env.NEXT_PUBLIC_VERSION_HEARTBEAT_INTERVAL)
    : 60000;

const Housekeeper = (props) => {
    const { pageLoading, Router, onStoreReady } = props;
    const { i18n, t } = useTranslation();
    const router = useRouter();
    const dispatch = useDispatch();

    /** states */
    const [CLEANING, setCLEANING] = useState(false);
    const [WORKER, setWORKER] = useState(null);

    /** effects */
    /**** process check versions */
    useEffect(() => {
        if (router.pathname === "/api-down" || router.pathname === "/503") {
            onStoreReady && onStoreReady(true);
            return;
        }
        if (!!pageLoading) {
            let reason = [];
            process.env.NODE_ENV === "development" && console.log(`%c Housekeeping `, "background: #666; color: #FFF");
            onStoreReady && onStoreReady(false);

            const _clientFrontVersion = localStorage?.getItem("_appVer");
            const _clientApiVersion = localStorage?.getItem("_apiVer");
            const _clientTimestamp = localStorage?.getItem("_userDate") ? localStorage?.getItem("_userDate") : false;
            const _appFrontVersion = packageJson.version;

            const _now = new Date(Date.now()).getDate().toString();

            getDbStatusFromAPI()
                .then((status) => {
                    if (status?.message?.type === "Error") {
                        process.env.NODE_ENV === "development" &&
                            console.log(
                                `%c API status: ERROR. Redirect to "/api-down"`,
                                "background: #B00; color: #FFF",
                                { Router, router, wl: window.location, status }
                            );

                        if (router.pathname !== "/api-down") {
                            router.push("/api-down", null, { locale: i18n.language });
                        }
                        // window.location.href=_redirect
                        return;
                    }

                    if (status === true) {
                        process.env.NODE_ENV === "development" &&
                            console.log(`%c API status: WAIT. Redirect to "/503"`, "background: #BB0; color: #FFF");
                        // Router.push("/503");
                        router.push("/503", null, { locale: i18n.language });
                        return;
                    }

                    process.env.NODE_ENV === "development" &&
                        console.log(`%c API status: OK. `, "background: #0B0; color: #FFF");

                    getApiVersionFromAPI()
                        .then((apiVersion) => {
                            const _appApiVersion = apiVersion;

                            if (apiVersion?.message?.type === "Error") {
                                process.env.NODE_ENV === "development" &&
                                    console.log(
                                        `%c API ver.:  ERROR. Redirect to "/api-down" `,
                                        "background: #B00; color: #FFF"
                                    );
                                Router.push("/api-down");
                                return;
                            }

                            if (
                                !_clientFrontVersion ||
                                _clientFrontVersion !== _appFrontVersion ||
                                !_clientApiVersion ||
                                _clientApiVersion !== _appApiVersion ||
                                !_clientTimestamp ||
                                _now !== _clientTimestamp
                            ) {
                                if (!_clientFrontVersion) reason.push(" No app version ");

                                if (_clientFrontVersion !== _appFrontVersion) reason.push(" App version change ");

                                if (!_clientApiVersion) reason.push(" No API version ");

                                if (_clientApiVersion !== _appApiVersion) reason.push(" API version change ");

                                if (!_clientTimestamp) reason.push(" No client date ");

                                if (_now !== _clientTimestamp) reason.push(" Date change ");

                                // process.env.NODE_ENV === "development" &&
                                // console.group(
                                //     `%c Storage status: STALE. \n Updating... `,
                                //     "background: #e9e995; color: #000"
                                // );

                                if (process.env.NODE_ENV === "development") {
                                    console.group(`%c Storage status: `, "background: #e9e995; color: #000");
                                    reason.forEach((r) => console.log(`%c ${r} `, "background: #999; color: #e9e995"));
                                    console.groupEnd();
                                    console.log(`%c Updating... `, "background: #e9e995; color: #000");
                                }

                                setCLEANING(true);

                                clearIDB({ _appApiVersion, _appFrontVersion, _now });
                            } else {
                                process.env.NODE_ENV === "development" &&
                                    console.log(`%c Storage status: OK. `, "background: #0B0; color: #FFF");
                                onStoreReady && onStoreReady(true);
                            }
                        })
                        .catch((e) => {
                            process.env.NODE_ENV === "development" && console.log(e);
                        });
                })
                .catch((e) => {
                    process.env.NODE_ENV === "development" && console.log(e);
                });
        }
    }, [pageLoading]);

    /** set worker */
    useEffect(() => {
        if (VERSION_HEARTBEAT_DISABLED) return;

        const housekeeperWorker = new WebWorker(HousekeeperWorker);
        housekeeperWorker.onmessage = function (event) {
            let _housekeeperResult = event.data;

            const _now = new Date(Date.now()).getDate().toString();
            const _clientTimestamp = localStorage?.getItem("_userDate") ? localStorage?.getItem("_userDate") : false;
            const _clientFrontVersion = localStorage?.getItem("_appVer");
            const _clientApiVersion = localStorage?.getItem("_apiVer");

            if (_clientTimestamp !== _now) {
                process.env.NODE_ENV === "development" && console.log(` housekeeperWorker: date change`);
                clearIDB({ _appApiVersion: _clientApiVersion, _appFrontVersion: _clientFrontVersion, _now });
            }

            // process.env.NODE_ENV === "development" && console.log(` housekeeperWorker:`, _housekeeperResult);
            getVersionsFromAPI()
                .then((res) => {
                    const { app, api, status } = res?.versions || {};

                    // process.env.NODE_ENV === "development" &&
                    console.log(`👀`);

                    if (
                        app?.message?.type === "Error" ||
                        api?.message?.type === "Error" ||
                        status?.message?.type === "Error"
                    ) {
                        // router.push("/api-down");
                        return;
                    }

                    const _appFrontVersion = app;

                    if (_clientFrontVersion !== app) {
                        process.env.NODE_ENV === "development" && console.log(` housekeeperWorker: APP version change`);
                        clearIDB({ _appApiVersion: api, _appFrontVersion, _now }).then(() => {
                            router.reload();
                        });
                    }

                    if (_clientApiVersion !== api) {
                        process.env.NODE_ENV === "development" && console.log(` housekeeperWorker: Api version change`);
                        clearIDB({ _appApiVersion: api, _appFrontVersion, _now });
                    }

                    if (!!status) {
                        process.env.NODE_ENV === "development" && console.log(` housekeeperWorker: DB update`);
                        clearIDB({ _appApiVersion: api, _appFrontVersion, _now }).then(() => {
                            router.push("/api-down");
                        });
                    }
                })
                .catch((error) => {})
                .finally(() => {});
        };
        setWORKER(housekeeperWorker);

        housekeeperWorker.postMessage(VERSION_HEARTBEAT_INTERVAL);
        return () => {
            housekeeperWorker.terminate();
        };
    }, []);

    /**** start worker */
    // useEffect(() => {
    //     if (!WORKER) return;
    //     WORKER.postMessage("start");
    // }, [WORKER]);

    /** handlers */
    const clearIDB = async ({ _appApiVersion, _appFrontVersion, _now }) => {
        try {
            return await Promise.all([
                dispatch(clearAggregatesFromIndexedDB()),
                dispatch(clearAreasFromIndexedDB()),
                dispatch(clearCATCalculatorsFromIndexedDB()),
                dispatch(clearCATCommonFromIndexedDB()),
                dispatch(clearCalendarFromIndexedDB()),
                dispatch(clearDATESFromIndexedDB()),
                dispatch(clearDBCommonFromIndexedDB()),
                dispatch(clearJTFromIndexedDB()),
                dispatch(clearListsTableFromIndexedDB()),
                dispatch(clearRepositoryromIndexedDB()),
                dispatch(clearSettingsChartBarsFromIndexedDB()),
                dispatch(clearSettingsTableFromIndexedDB()),
                dispatch(clearStorytellingFromIndexedDB()),
                dispatch(clearTableFiltersFromIndexedDB()),
                dispatch(clearVALCommonFromIndexedDB()),
                dispatch(clearWSKFromIndexedDB()),
            ])
                .then((res) => {
                    const _fetched = res.every((r) => !!r && !r?.error);

                    // process.env.NODE_ENV === "development" && console.log("clearIDB ", res, { _fetched });
                    process.env.NODE_ENV === "development" &&
                        console.log(
                            `%c ClearIDB: ${_fetched ? "OK. " : "Oops..."}`,
                            `background: ${_fetched ? "#0B0" : "#B00"}; color: #FFF`,
                            _fetched ? "" : res
                        );

                    localStorage.clear();

                    localStorage.setItem("_appVer", _appFrontVersion);
                    localStorage.setItem("_apiVer", _appApiVersion);
                    localStorage?.setItem("_userDate", _now);

                    onStoreReady && onStoreReady(true);
                    setCLEANING(false);
                    setTimeout(() => {
                        // Router.reload();
                    }, 100);

                    return true;
                })
                .catch(
                    (err) =>
                        process.env.NODE_ENV === "development" &&
                        console.log("%c fetchIDB: error", "background:#F00", err)
                )
                .finally(() => {});
        } catch (error) {}

        // const _deleteDB = await deleteDatabase().then(async (res) => {
        //     localStorage.clear();

        //     localStorage.setItem("_appVer", _appFrontVersion);
        //     localStorage.setItem("_apiVer", _appApiVersion);
        //     localStorage?.setItem("_userDate", _now);

        //     setTimeout(() => {
        //         onStoreReady && onStoreReady(true);
        //         Router.reload();
        //     }, 100);

        //     return true;
        // });
    };

    return (
        <>
            {(!!pageLoading || !!CLEANING) && (
                <>
                    <PagePreloader
                        label={!!CLEANING ? t("Przygotowanie{{dots}}", { dots: "..." }) : " "}
                        footer={"Housekeeper"}
                    />
                    <p
                        aria-live="assertive"
                        id="__apreloader-page-announcer__"
                        role="alert"
                        aria-roledescription={" "}
                        style={{
                            border: 0,
                            clip: "rect(0px, 0px, 0px, 0px)",
                            height: 1,
                            margin: -1,
                            overflow: "hidden",
                            padding: 0,
                            position: "absolute",
                            width: 1,
                            whiteSpace: "nowrap",
                            overflowWrap: "normal",
                        }}
                    >
                        {!!CLEANING ? t("Przygotowanie{{dots}}", { dots: "..." }) : t("Ładowanie")}
                    </p>
                </>
            )}
        </>
    );
};

export default Housekeeper;
